import React from 'react';

export default [
  {
    title: 'How does the tracking system work?',
    content: 'You will be able to create your affiliate links, which hold your unique Affiliate ID through our Affiliate portal. This allows us to track bookings made from your site. All bookings with the same Affiliate ID will be linked to the same Affiliate Partner. Also, The Affiliate ID utilizes cookies to track visitors directed to TakeMeTour for up to 30 days. If these visitors make a booking within 30 days, your Affiliate ID will be registered, and you will be able to enjoy the commission share.'
  },
  {
    title: "How long do the cookies last in the user's browser?",
    content: 'The cookies last for 30 days. This ensures that even if your readers took awhile to decide and make the booking, you would still be duly commissioned.'
  },
  {
    title: 'How frequent is the commission pay-out?',
    content: 'Commission is summarized monthly and will be paid out within the following 15 days. For example, the commission you’ve earned between 1-30 April 2019 will be paid out through PayPal by 15 May 2019.'
  },
  {
    title: 'Can I get paid in USD or other currencies?',
    content: 'Yes. The commission payout will be calculated and sent in Thai Baht (THB), but you can select the receiving currency of your choice in Paypal. Any fees incurred by Paypal will be borne by you.'
  },
  {
    title: 'How are the commission and bonus calculated?',
    content: (
      <span>
        <p>For every tour booked through your Affiliate ID, you can earn a 200THB base commission per tour booked.</p>
        <p>For every attraction ticket or airport service booked through your Affiliate ID, you can earn a commission of 50THB per booking.</p>
        <p>The extra bonus will be offered occasionally so please stay tune with us!</p>
      </span>
    )
  },
  {
    title: 'Do I have to work exclusively with TakeMeTour?',
    content: (
      <span>
        No, you don’t have to. You are free to combine our offerings with other providers as you wish. <br/><br/>However, if you would like to work exclusively with TakeMeTour, feel free to let us know
      </span>
    )
  }
];
